<template>
  <b-nav vertical pills>
    <b-nav-item
      v-for="item in menuItems"
      :key="item.title"
      :to="item.route"
      :exact="item.exact"
      active-class="active"
      :active="isActive(item)"
    >
      {{item.title}}
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'SideNav',

  props: {
    menuItems: {
      type: Array,
      required: true,
    }
  },

  methods: {
    isActive(item) {
      const isActiveFunc = item.isActive;
      if(isActiveFunc === undefined) {
        return false;
      }
      return isActiveFunc();
    },
  },
}
</script>

<style scoped>
.nav {
  white-space: nowrap;
}
a.active {
  border-radius: 0;
}
</style>
